export { Drawer as _Drawer } from './drawer/Drawer.js';
export type { DrawerProps as _DrawerProps } from './drawer/Drawer.js';

export { useDialog as _useDialog } from './hooks/useDialog.js';
export type {
  AriaDialogProps as _AriaDialogProps,
  DialogAria as _DialogAria,
} from './hooks/useDialog.js';
export {
  DismissButton,
  useOverlay as _useOverlay,
} from './hooks/useOverlay.js';
export type {
  DismissButtonProps,
  OverlayAria,
  OverlayTriggerState,
  UseOverlayProps as _UseOverlayProps,
} from './hooks/useOverlay.js';
export { useOverlayWithTrigger } from './hooks/useOverlayWithTrigger.js';
export type {
  ModalAriaProps,
  OverlayPlacement,
  OverlayProps,
  OverlayRefs,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  OverlayTriggerProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  OverlayWithTriggerProps,
  OverlayWithTriggerReturnType,
  TriggerProps,
  UseOverlayWithTriggerBaseProps,
  UseOverlayWithTriggerControlledProps,
  UseOverlayWithTriggerProps,
  UseOverlayWithTriggerUncontrolledProps,
} from './hooks/useOverlayWithTrigger.js';
export type {
  HeightStrategy,
  OverlaySizeStrategyRange,
  WidthStrategy,
} from './types/sizing.types.js';
export { useTooltipState as _useTooltipState } from './hooks/useTooltipState.js';
export type { TooltipStateProps as _TooltipStateProps } from './hooks/useTooltipState.js';
export type { BaseModalProps } from './modal/BaseModal.js';
export { Modal } from './modal/Modal.js';
export type { ModalProps } from './modal/Modal.js';
export type { ModalSizeOptionsType } from './modal/types.js';
export { Overlay } from './overlay/Overlay.js';
export type { OverlayComponentProps } from './overlay/Overlay.js';
export { Sheet } from './sheet/Sheet.js';
export type { SheetProps } from './sheet/Sheet.js';
export { Tooltip } from './tooltip/Tooltip.js';
export type {
  TooltipBaseProps,
  TooltipProps,
} from './tooltip/tooltip.types.js';
export { basePlacements } from './types/placement.js';
export type { basePlacementsType } from './types/placement.js';
